import { render, staticRenderFns } from "./Page-Settings.vue?vue&type=template&id=1e5c131f"
import script from "./Page-Settings.vue?vue&type=script&lang=js"
export * from "./Page-Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports